import ApiEndpoint, { ApiResponse } from '../../network/ApiEndpoint'

export type GetScheduleContentForChannelProps = {
  slug: string
  page: number
  perPageCount: number
}

export const getScheduleContentForChannel = async ({
  slug,
  page,
  perPageCount
}: GetScheduleContentForChannelProps) => {
  try {
    const resultResponse: ApiResponse = await ApiEndpoint.call({
      path: 'timeline_objects/collections/livestreams',
      params: {
        per_page: perPageCount,
        page: page,
        company: slug
      }
    })
    const responseData = await resultResponse

    return responseData
  } catch (e: any) {
    // @ts-ignore
    throw new Error(e.message)
  }
}
